import { useRef } from "react";

const ScrollingSection = ({sectionContent, imageUrl }) => {
  const sectionRef = useRef(null);

  return (
  <div className="relative min-h-screen flex flex-col justify-center items-center text-white overflow-hidden">
      {/* Black Transparent Overlay - Removed as the content will now cover it entirely */}
      {/* The background image itself will be covered by the opaque sectionContent */}
      <div
        className="absolute inset-0 bg-cover bg-center z-0"
        style={{
          backgroundImage: `url(${imageUrl})`,
          backgroundAttachment: "fixed", // This creates the parallax-like effect
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        onError={(e) => { e.target.onerror = null; e.target.style.backgroundImage = 'url("[https://placehold.co/1920x1080/cccccc/000?text=Background+Image+Error](https://placehold.co/1920x1080/cccccc/000?text=Background+Image+Error)")' }}
      ></div>

      {/* Section Content (Now fills the entire space and is fully opaque) */}
      <div className="relative z-10 w-full flex justify-center items-center">
        {sectionContent}
      </div>
    </div>
  );
};

export default ScrollingSection;
